export default {

    // logo: require("./logo.svg").default,
    logo: require("./logo.png"),
    stripe: require("./stripeLogo.png"),
    defaultCard: require("./defaultCard.png"),
    profileImg: require("./profile-user.png"),


}